import { NgModule } from '@angular/core';
import { provideRouter, RouterModule } from '@angular/router';
import { CoreEffects } from '@next/core-lib';
import { provideAgrCore } from '@next/core-lib/app';
import { I18nBrowserEffects } from '@next/core-lib/browser';
import { I18nEffects } from '@next/core-lib/i18n';
import { NavigationEffects } from '@next/core-lib/navigation';
import { provideAgrRouterStore } from '@next/core-lib/router-store';
import { provideAgrSettings } from '@next/core-lib/settings';
import { SiteEffects } from '@next/core-lib/site';
import { AgrWrapperSiteSidenavModule } from '@next/core-lib/wrapper-site-sidenav';
import { provideEffects } from '@ngrx/effects';
import { provideState, provideStore } from '@ngrx/store';

import { ActiveIngredientSettingsModule } from './activeingredientsetting/activeingredientsetting.module';
import { AppComponent } from './app.component';
import { appRoutes } from './app.routes';
import { CropSettingsModule } from './cropsetting/cropsetting.module';
import { SharedModule } from './shared/shared.module';
import { cropsReducer } from './store/crops/crops.reducer';
import { AppEffects } from './store/effects';
import { ingredientsReducer } from './store/ingredients/ingredients.reducer';

@NgModule({
  declarations: [AppComponent],
  imports: [
    RouterModule,
    SharedModule,
    CropSettingsModule,
    ActiveIngredientSettingsModule,
    AgrWrapperSiteSidenavModule,
  ],
  providers: [
    provideRouter(appRoutes),
    provideStore(
      {},
      {
        runtimeChecks: {
          strictStateImmutability: true,
          strictActionImmutability: true,
          strictStateSerializability: true,
          strictActionSerializability: true,
        },
      },
    ),
    provideAgrRouterStore(),
    provideAgrCore(),
    provideAgrSettings(),
    provideEffects([CoreEffects, I18nEffects, I18nBrowserEffects, SiteEffects, NavigationEffects]),

    provideEffects(AppEffects),
    provideState('crops', cropsReducer),
    provideState('ingredients', ingredientsReducer),
  ],
})
export class AppModule {}
